import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  TextField,
  Chip
} from "@mui/material";
import {
  BackButton,
  BackgroundStyle,
  BigHeading,
  FlexContainer,
  LightBlueContainer,
  ListContainer,
  SearchingBoxContainer,
  LongBlueButton,
  ShortBlueButton,
  BarContainer,
  WhiteContainer,
  LabelContainer,
  DocumentButton,
  ButtonContainer,
  StyledLink,
  WorkDetailContainer,
  OverlayActiveStyle,
  OverlayBaseContainer,
  OverlaySearchEquipmentContainer,
  SearchEquipmentContainer,
  OverlayCloseLogo,
} from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import {
  Dispatch,
  MouseEventHandler,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs, { Dayjs } from "dayjs";
import SearchBox from "../components/SearchBox";
import ProjectBar from "../components/ProjectBar";
import FormButton from "../components/FormButton";
import FormLabel from "../components/FormLabel";
import axios from "axios";
import FormLongLabel from "../components/FormLongLabel";
import { useLocation, useNavigate } from "react-router-dom";
import MainContent from "../components/MainContent";
import CloseIcon from "@mui/icons-material/Close";
import { AddEquipmentContainer } from "../components/Containers/AddEquipmentContainer";
import FormDropDownList from "../components/FormDropDownList";
import BigMapCard from "../components/MapBigCard";
import RemovableFormDropDownList from "../components/RemovableFormDropDownList";
import { projectPageName } from "../components/PageName";
import { useGetWorkerDropdownListQuery } from "../features/worker/workerSlice";
import { WorkerAsDropdownListItemModel } from "../models/WorkerModel";
import {
  useCreateScheduleMutation,
  useLazyGetScheduleByIdQuery,
  useLazyGetWorkScheduleFileQuery,
  useUpdateScheduleMutation,
} from "../features/schedule/scheduleSlice";
import { deleteIcon } from "../assets/imgs";
import { DocumentTypeMap, siteDocements, DocumentFile } from "../models/WorkScheduleModel";
import EquipmentRecordTable from "../components/EquipmentRecordTable";
import { useTranslation } from "react-i18next";
import { DataGrid } from "@mui/x-data-grid";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useLazyGetUserDropdownListQuery } from "../features/auth/authApiSlice";
import { use } from "i18next";
import MultiFileUpload from "../components/MultiFileUpload";

const AddWorkSchedulePage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const getLocation = useLocation();
  const entry = getLocation.state?.entry;
  // const editEntry = getLocation.state?.editEntry;
  // const projectId = getLocation.state?.projectId;
  const workTypeArray = ["Confined Space", "Surface"];
  // const getLocation = useLocation();
  var project = getLocation?.state?.project;
  var position = getLocation?.state?.position;
  // console.log("project,", project)
  // console.log("position,", position)
  // console.log("entry,", entry)
  const { data: workers } = useGetWorkerDropdownListQuery();
  const [createSchedule, { error }] = useCreateScheduleMutation();
  const [updateSchedule] = useUpdateScheduleMutation();
  const [getScheduleQuery] = useLazyGetScheduleByIdQuery();
  const [getWorkScheduleFile] = useLazyGetWorkScheduleFileQuery();
  const [getUserDropdownList] = useLazyGetUserDropdownListQuery();
  const [date, setDate] = useState<any>(dayjs(null));
  const [startTime, setStartTime] = useState<any>(dayjs(null));
  const [endTime, setEndTime] = useState<any>(dayjs(null));
  const [updateTime, setUpdateTime] = useState<string>();
  const [updatedBy, setUpdatedBy] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [riskAssessmentStatus, setRiskAssessmentStatus] = useState("");
  const [status, setStatus] = useState("");
  const [userList, setUserList] = useState<{ id: string; name: string }[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [workType, setWorkType] = useState("Surface");

  const maxWorkerNumber = 9;
  const [equipmentTables, setEquipmentTables] = useState<
    Array<Array<TableRow>>
  >(() => Array(maxWorkerNumber).fill([]));
  // const [equipmentTables, setEquipmentTables] = useState<Array<Array<TableRow>>>([]);
  const [onSiteWorkerDropdownListItems, setOnSiteWorkerDropdownListItems] =
    useState([]);
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [workerItem, setWorkerItem] = useState<WorkerAsDropdownListItemModel[]>(
    []
  );

  const [docRiskAssessment, setDocRiskAssessment] =
    useState<siteDocements | null>();
  const [riskAssessment, setRiskAssessment] = useState<File | null>(null);
  const [isRiskAssessmentOpened, setRiskAssessmentOpened] = useState<boolean>(false);
  const riskAssessmentFileInputRef = useRef<HTMLInputElement>(null);
  const handleRiskAssessmentButtonClick: MouseEventHandler<
    HTMLButtonElement
  > = () => {
    if (riskAssessmentFileInputRef.current) {
      riskAssessmentFileInputRef.current.click();
    }
  };
  const handleRiskAssessmentFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setRiskAssessment(selectedFile);
      setDocRiskAssessment(null);
    }
  };

  const [workPermit, setWorkPermit] = useState<File | null>(null);
  const [isWorkPermitOpened, setWorkPermitOpened] = useState<boolean>(false);
  const [docWorkPermit, setDocWorkPermit] = useState<siteDocements | null>();
  const workPermitFileInputRef = useRef<HTMLInputElement>(null);
  const handleWorkPermitButtonClick: MouseEventHandler<
    HTMLButtonElement
  > = () => {
    if (workPermitFileInputRef.current) {
      workPermitFileInputRef.current.click();
    }
  };
  const handleWorkPermitFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setWorkPermit(selectedFile);
      setDocWorkPermit(null);
    }
  };

  const [equipmentChecklist, setEquipmentChecklist] = useState<File | null>(
    null
  );
  const [docEquipmentChecklist, setDocEquipmentChecklist] =
    useState<siteDocements | null>();
  const equipmentChecklistFileInputRef = useRef<HTMLInputElement>(null);
  const handleEquipmentChecklistButtonClick: MouseEventHandler<
    HTMLButtonElement
  > = () => {
    if (equipmentChecklistFileInputRef.current) {
      equipmentChecklistFileInputRef.current.click();
    }
  };
  const handleEquipmentChecklistFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setEquipmentChecklist(selectedFile);
      setDocEquipmentChecklist(null);
    }
  };

  // const documentTypeMap: DocumentTypeMap = {
  //   ra: {
  //     setDoc: setDocRiskAssessment,
  //     setState: setRiskAssessmentFiles,
  //   },
  //   wp: {
  //     setDoc: setDocWorkPermit,
  //     setState: setWorkPermit,
  //   },
  //   ec: {
  //     setDoc: setDocEquipmentChecklist,
  //     setState: setEquipmentChecklist,
  //   },
  // };

  const getLink = function (file: any) {
    // console.log("file", file)
    if (file) {
      // console.log("getLink", file.name)
      return (
        <a
          onClick={async () => {
            await getFile(file.id, file.name, file.contentType);
          }}
          href={"javascript:;"}
          target="_self"
          rel="noopener noreferrer"
        >
          {file.name}
        </a>
      );
    } else {
      return "None";
    }
  };

  const getFile = async function (id: string, name: string, type: string) {
    try {
      const dataUrl = await getWorkScheduleFile(id).unwrap();
      const blob = await fetch(dataUrl).then((r) => r.blob());
      const file = new File([blob], name, { type: type });
      displayImageInNewTab(file, name);
    } catch (error) {
      alert("fails to open the file.");
      console.error(error);
      // navigate('/worker-detail', { state: { workerID: workerId } })
    } finally {
    }
  };

  const displayImageInNewTab = function (blob: Blob, filename: string) {
    const imageUrl = URL.createObjectURL(blob);
    const newTab = window.open(imageUrl);
  };

  const handleDropDownListChange = (
    workerStates: any,
    event: SelectChangeEvent,
    index: number
  ) => {
    const updatedWorkerStates = [...workerStates];
    const selectedWorker = workerItem.find(
      (item) => item.workerName === event.target.value
    );

    // Find the previously selected worker in this dropdown list
    const prevSelectedWorker = workerItem.find(
      (item) => item.id === updatedWorkerStates[index].userId
    );

    if (!updatedWorkerStates.find((item) => item.name === event.target.value)) {
      updatedWorkerStates[index].userId = selectedWorker?.id;
      updatedWorkerStates[index].name = selectedWorker?.workerName;

      // Remove the selected value from other DDLs
      updatedWorkerStates.forEach((worker, idx) => {
        if (idx !== index) {
          worker.items = worker.items.filter(
            (item: any) => item !== event.target.value
          );
        }
      });

      setWorkerStates(updatedWorkerStates);
    } else {
      alert("Please select another worker.");
    }

    // If a previously selected worker exists, add them back to the items of other DDLs
    if (prevSelectedWorker) {
      updatedWorkerStates.forEach((worker) => {
        if (worker.name !== prevSelectedWorker.workerName) {
          worker.items.push(prevSelectedWorker.workerName);
        }
      });
      setWorkerStates(updatedWorkerStates);
    }

  };
  useEffect(() => {
    if (workers) {
      const workerItems: any[] = workers.map((item: any) => ({
        id: item.id,
        workerName: item.workerName,
        rfidNumber: item.rfidNumber,
        disabled: false,
      }));
      setWorkerItem(workerItems);
      const workerNames = workers.map((item: any) => item.workerName);
      setOnSiteWorkerDropdownListItems(workerNames);
      const updatedWorkerStates = [...workerStates];
      for (var i = 0; i < workerStates.length; i++) {
        updatedWorkerStates[i].items = workerItems.map(
          (item) => item.workerName
        );
      }
      setWorkerStates(updatedWorkerStates);
    }
  }, [workers]);

  useEffect(() => {
    if (workerItem.length != 0) handleProjectData(workerItem);
    if (localStorage.accessToken) {
      getUserDropdownList().then((response: any) => {
        if (response.status == "fulfilled") {
          console.log("getUserDropdownList", response?.data);
          setUserList(response?.data);
        }
      });
    }
  }, [workerItem]);

  const handleProjectData = async (curWorkerStatus: any) => {
    try {
      if (localStorage.accessToken && entry) {
        const response = await getScheduleQuery({
          projectId: project?.id,
          locationId: position?.id,
          id: entry?.id,
        }).unwrap();

        console.log("response?.data: ", response);

        const workersData = response?.workers || [];
        const siteEquipments = response?.siteEquipments || [];
        setWorkType(response?.workType || "Surface");

        // Initialize worker states
        let workers = [...workerStates];
        let equipments = [...equipmentTables];

        // Clear existing certified workers (keep Competent Person and Standby Person if Confined Space)
        if (response.workType === "Surface") {
          workers = workers.filter((w) => w.workerType !== 3); // Keep only non-certified workers (empty in Surface mode initially)
        } else {
          workers = workers.filter((w) => w.userId !== '');
          workers = workers.slice(0, 2); // Keep Competent Person and Standby Person for Confined Space
        }

        // Initialize equipment tables (start with site equipment)
        equipments = [siteEquipments];

        // Map workers from payload
        const sortedWorkers = [...workersData].sort((a, b) => {
          if (a.seq !== b.seq) return (a.seq || 0) - (b.seq || 0);
          return a.typeId - b.typeId;
        });

        sortedWorkers.forEach((worker, index) => {
          const foundWorker = curWorkerStatus.find(
            (item: any) => item.id === worker.id
          );
          if (!foundWorker) return;

          // Add worker state
          if (response.workType === "Surface" && worker.typeId !== 3) {
            return; // Skip non-certified workers in Surface mode
          }

          const workerState = {
            id: workers.length,
            title:
              worker.typeId === 1
                ? "Competent person"
                : worker.typeId === 2
                  ? "Standby Person"
                  : `${t('Certified Worker')} ${workers.filter((w) => w.workerType === 3).length + 1}`,
            userId: worker.id,
            name: foundWorker.workerName,
            workerType: worker.typeId,
            seq: worker.seq || index,
            items: [], // Will be populated later
          };
          workers.push(workerState);

          // Add equipment table for Certified Workers
          if (worker.typeId === 3) {
            equipments.push(worker.equipments || []);
          }
        });

        // Update dropdown items to exclude selected workers
        const unassignedWorkers = onSiteWorkerDropdownListItems.filter(
          (worker: any) => !workers.find((state) => state.name === worker)
        );
        workers.forEach((state) => {
          state.items = state.name ? [state.name, ...unassignedWorkers] : unassignedWorkers;
        });

        // Set states
        setWorkerStates(workers);
        setEquipmentTables(equipments);
        setEquipmentStates(
          equipments.map((equip, index) => ({
            id: index,
            title: index === 0 ? "On Site Equipment" : `${t('Certified Worker')} ${index}`,
            equipmentType: index === 0 ? "2" : "1",
            workerType: index === 0 ? 0 : 3,
          }))
        );

        // Set other fields
        setDate(dayjs(response?.workDate, "DD/MM/YYYY"));
        setStartTime(dayjs(response?.startTime, "HH:mm"));
        setEndTime(dayjs(response?.endTime, "HH:mm"));
        setUpdateTime(response?.updatedOn);
        setUpdatedBy(response?.updatedBy);
        setCreatedBy(response?.createdBy);
        setSelectedUsers(response?.allowedCheckInAccounts || []);
        setRiskAssessmentOpened(response?.isRiskAssessmentOpened);
        setWorkPermitOpened(response?.isWorkPermitOpened);
        setRiskAssessmentStatus(response?.riskAssessmentStatus);
        setStatus(response?.status);

        // Set documents
        response?.siteDocements?.forEach((document: any) => {
          // const { setDoc, setState } = documentTypeMap[document.type] || {};
          // if (setDoc && setState) {
          //   setDoc(document);
          //   setState(document);
          // }

          setRiskAssessmentFiles(response?.siteDocements?.filter((document: any) => document.type === "ra"));
          setWorkPermitFiles(response?.siteDocements?.filter((document: any) => document.type === "wp"));
          setEquipmentChecklistFiles(response?.siteDocements?.filter((document: any) => document.type === "ec"));
        });
      }
    } catch (error) {
      setOpenConfirmationBox(false);
      alert("An error occurred. Please refresh (F5) or login again.");
      console.log(error);
    }
  };

  // Add a new useEffect to handle workType changes
  useEffect(() => {
    const updatedWorkerStates = [...workerStates];
    updatedWorkerStates.forEach((state) => {
      if (workType === "Surface") {
        if (state.workerType === 3) {
          state.items = onSiteWorkerDropdownListItems;
        } else {
          state.items = [];
        }
      } else {
        state.items = onSiteWorkerDropdownListItems;
      }
    });
    setWorkerStates(updatedWorkerStates);
  }, [workType, onSiteWorkerDropdownListItems]);

  const handleAddRiskAssessment = () => {
    // 如果是新建模式，傳遞當前表單數據
    if (isRiskAssessmentOpened) {
      navigate("/risk-assessment", {
        state: {
          mode: 'edit',
          entry: entry,
          project: project,
          position: position,
          scheduleID: entry.id,
        }
      });
    } else {
      navigate("/risk-assessment", {
        state: {
          mode: 'create',
          scheduleID: entry.id,
          entry: entry,
          project: project,
          position: position,
          formData: {
            site: project?.name || '',
            content: workType || '',
            contractor: project?.contractorName || '',
            // 可以傳遞更多相關數據
          }
        }
      });
    }
  }

  const handleAddWorkPermit = () => {
    // 如果是新建模式，傳遞當前表單數據
    if (isWorkPermitOpened) {
      navigate("/work-permit", {
        state: {
          mode: 'edit',
          entry: entry,
          project: project,
          position: position,
          scheduleID: entry.id,
        }
      });
    } else {
      navigate("/work-permit", {
        state: {
          mode: 'create',
          scheduleID: entry.id,
          entry: entry,
          project: project,
          position: position,
          formData: {
            site: project?.name || '',
            content: workType || '',
            contractor: project?.contractorName || '',
            // 可以傳遞更多相關數據
          }
        }
      });
    }
  }

  const handleAddWorker = () => {
    // const workers = onSiteWorkerDropdownListItems.filter((worker: any) => worker !== workerStates)
    const filteredOnSiteWorkerDropdownListItems =
      onSiteWorkerDropdownListItems.filter(
        (worker) => !workerStates.find((state) => state.name === worker)
      );

    setWorkerStates((prevWorkerStates) => {
      const newWorkerState = {
        id: workerStates.length,
        title: `${t('Certified Worker')} ${workerStates.length - 1}`,
        userId: "",
        name: "",
        workerType: 3,
        seq: workerStates.length - 1,
        // handleValueChange: handleDropDownListChange,
        items: filteredOnSiteWorkerDropdownListItems,
      };
      return [...prevWorkerStates, newWorkerState];
    });


    setEquipmentStates((prevEquipmentStates) => {
      const newEquipmentState = {
        id: equipmentStates.length,
        title: `${t('Certified Worker')} ${equipmentStates.length}`,
        equipmentType: "1",
        workerType: 3,
      };
      return [...prevEquipmentStates, newEquipmentState];
    });
    // new
  };

  const handlePermissionChange = (
    event: React.SyntheticEvent<Element, Event>,
    value: { id: string; name: string }[]
  ) => {
    var newUsers = value.map((item) => item.id);
    const removedUsers = selectedUsers?.filter(
      (userId) => !newUsers.includes(userId)
    );

    var curUsers: string[] = [];
    if (selectedUsers) {
      curUsers = selectedUsers;
      if (removedUsers)
        curUsers = curUsers.filter((userId) => !removedUsers.includes(userId));

      newUsers = newUsers.filter((userId) => !selectedUsers.includes(userId));
    }

    if (selectedUsers) {
      curUsers = selectedUsers;
      if (removedUsers)
        curUsers = curUsers.filter((userId) => !removedUsers.includes(userId));
    }

    const updatedSelectedUsers = Array.from(
      new Set([...curUsers, ...newUsers])
    );
    setSelectedUsers(updatedSelectedUsers);
    console.log("handleAutocompleteChange", updatedSelectedUsers);
  };

  const handleSelectRows = (selectedRows: TableRow[], rowIndex: number) => {
    setEquipmentTables((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex] = selectedRows.map((row) => ({
        ...row,
        checked: true, // Set the checked property to true for the selected rows
      }));
      // console.log("updatedRows, ", updatedRows)
      return updatedRows;
    });
    // console.log("equipmentTables, ", equipmentTables)
    // console.log("equipmentStates, ", equipmentStates)
  };

  const [equipmentStates, setEquipmentStates] = useState<
    {
      id: Number;
      title: string;
      equipmentType: string;
      workerType: number;
    }[]
  >([
    {
      id: 0,
      title: "On Site Equipment",
      equipmentType: "2",
      workerType: 0,
    },
    {
      id: 1,
      title: "Certified Worker 1",
      equipmentType: "1",
      workerType: 3,
    },
    {
      id: 2,
      title: "Certified Worker 2",
      equipmentType: "1",
      workerType: 3,
    },
  ]);

  const [workerStates, setWorkerStates] = useState<
    {
      id: number;
      title: string;
      userId: string;
      name: string;
      workerType: number;
      seq: number;
      items: string[];
    }[]
  >([
    {
      id: 0,
      title: "Competent person",
      userId: "",
      name: "",
      workerType: 1,
      seq: 1,
      items: [],
    },
    {
      id: 1,
      title: "Standby Person",
      userId: "",
      name: "",
      workerType: 2,
      seq: 1,
      items: [],
    },
    {
      id: 2,
      title: "Certified Worker 1",
      userId: "",
      name: "",
      workerType: 3,
      seq: 1,
      items: [],
    },
    {
      id: 3,
      title: "Certified Worker 2",
      userId: "",
      name: "",
      workerType: 3,
      seq: 2,
      items: [],
    },
  ]);

  // 更新為支援多檔案上傳的狀態
  const [riskAssessmentFiles, setRiskAssessmentFiles] = useState<DocumentFile[]>([]);
  const [workPermitFiles, setWorkPermitFiles] = useState<DocumentFile[]>([]);
  const [equipmentChecklistFiles, setEquipmentChecklistFiles] = useState<DocumentFile[]>([]);

  // 更新文件處理函數
  const handleMultiFileChange = (
    files: DocumentFile[],
    fileType: 'ra' | 'wp' | 'ec'
  ) => {
    console.log("handleMultiFileChange", files);
    switch (fileType) {
      case 'ra':
        setRiskAssessmentFiles(files);
        break;
      case 'wp':
        setWorkPermitFiles(files);
        break;
      case 'ec':
        setEquipmentChecklistFiles(files);
        break;
    }
  };

  const handleCreateSchedule = async () => {
    const workerList: Array<{
      id: string;
      typeId?: number;
      equipments?: string[];
      seq?: number;
    }> = [];

    // Filter workers based on work type
    const filteredWorkerStates =
      workType === "Surface"
        ? workerStates.filter((x) => x.workerType === 3)
        : workerStates;

    filteredWorkerStates.forEach((worker, i) => {
      // Only include workers with a valid userId
      if (!worker.userId) return;

      // Calculate the equipment table index
      let equipmentTableIndex: number | null = null;
      if (worker.workerType === 3) {
        // For certified workers, map to the correct equipment table
        // In Surface mode, first certified worker maps to equipmentTables[1], second to [2], etc.
        // In Confined Space mode, certified workers start at index 2 in workerStates, so adjust accordingly
        const certifiedWorkerIndex = workType === "Surface" ? i : i - 2;
        equipmentTableIndex = certifiedWorkerIndex + 1; // equipmentTables[0] is for site equipment
      }

      const equipments =
        equipmentTableIndex !== null &&
          equipmentTableIndex < equipmentTables.length
          ? equipmentTables[equipmentTableIndex].map((row) => row.id.toString())
          : [];

      workerList.push({
        id: worker.userId,
        typeId: worker.workerType,
        equipments,
        seq: worker.seq,
      });
    });

    const documentTypes = ["ra", "wp", "ec"];
    const documentList: { type: string; files: File[]; ids: string[] }[] = [];

    documentTypes.forEach((documentType) => {
      let files: File[] = [];
      let ids: string[] = [];

      switch (documentType) {
        case "ra":
          files = riskAssessmentFiles.map(f => f.file).filter(f => f !== null) as File[];
          ids = riskAssessmentFiles.map(f => f.id).filter(id => !id.startsWith('temp_'));
          break;
        case "wp":
          files = workPermitFiles.map(f => f.file).filter(f => f !== null) as File[];
          ids = workPermitFiles.map(f => f.id).filter(id => !id.startsWith('temp_'));
          break;
        case "ec":
          files = equipmentChecklistFiles.map(f => f.file).filter(f => f !== null) as File[];
          ids = equipmentChecklistFiles.map(f => f.id).filter(id => !id.startsWith('temp_'));
          break;
      }

      if (files.length > 0) {
        documentList.push({ type: documentType, files, ids });
      }
    });

    try {
      if (localStorage.accessToken) {
        const schedule = {
          projectId: project?.id,
          locationId: position?.id,
          model: {
            workDate: date?.format("DD/MM/YYYY"),
            startTime: startTime?.format("HH:mm:ss"),
            endTime: endTime?.format("HH:mm:ss"),
            workType: workType,
            siteEquipments: equipmentTables[0] ?? [],
            workers: workerList.map((worker) => ({
              id: worker.id,
              typeId: worker.typeId,
              equipments: worker.equipments ?? [],
            })),
            siteDocuments: documentList.map((document) => ({
              type: document.type,
              files: document.files as File[],
            })),
            allowedCheckInAccounts: selectedUsers,
          },
        };

        const formData = new FormData();
        formData.append("projectId", schedule.projectId);
        formData.append("locationId", schedule.locationId);
        formData.append("model.workDate", schedule.model.workDate || "");
        formData.append("model.startTime", schedule.model.startTime || "");
        formData.append("model.endTime", schedule.model.endTime || "");
        formData.append("model.workType", schedule.model.workType || "");
        ((equipmentTables[0] as any) || []).forEach((x: any, i: number) => {
          formData.append(`model.siteEquipments[${i}]`, x.id);
        });
        schedule.model.allowedCheckInAccounts.forEach((user, index) => {
          formData.append(`model.allowedCheckInAccounts[${index}]`, user);
        });
        schedule.model.workers.forEach((worker, index) => {
          formData.append(`model.workers[${index}].id`, worker.id);
          formData.append(
            `model.workers[${index}].typeId`,
            (worker.typeId as any) || ""
          );
          worker.equipments.forEach((equipment: any, subIndex: any) => {
            formData.append(
              `model.workers[${index}].equipments[${subIndex}]`,
              equipment
            );
          });
        });
        documentList.forEach((document, index) => {
          document.files.forEach((file, fileIndex) => {
            formData.append(
              `model.siteDocuments[${index}].files[${fileIndex}]`,
              file
            );
          });
          document.ids.forEach((id, idIndex) => {
            formData.append(
              `model.siteDocuments[${index}].ids[${idIndex}]`,
              id
            );
          });
          formData.append(
            `model.siteDocuments[${index}].type`,
            document.type
          );
        });

        await createSchedule({
          projectId: schedule.projectId,
          locationId: schedule.locationId,
          formData,
        }).then((res) => {
          if ("error" in res) {
            console.log(res.error);
            alert(`Create Schedule failed: ${res.error}`);
          } else {
            alert("Create Schedule Success");
            navigate("/work-schedule", {
              state: { project: project, position: position },
            });
          }
        });
      }
    } catch (error) {
      alert("An error occurred. Please refresh (F5) or login again.");
      console.log(error);
    }
  };

  const handleUpdateSchedule = async () => {
    const workerList: Array<{
      id: string;
      typeId?: number;
      equipments?: string[];
      seq?: number;
    }> = [];

    // Filter workers based on work type
    const filteredWorkerStates =
      workType === "Surface"
        ? workerStates.filter((x) => x.workerType === 3)
        : workerStates;

    filteredWorkerStates.forEach((worker, i) => {
      // Only include workers with a valid userId
      if (!worker.userId) return;

      // Calculate the equipment table index
      let equipmentTableIndex: number | null = null;
      if (worker.workerType === 3) {
        // For certified workers, map to the correct equipment table
        const certifiedWorkerIndex = workType === "Surface" ? i : i - 2;
        equipmentTableIndex = certifiedWorkerIndex + 1; // equipmentTables[0] is for site equipment
      }

      const equipments =
        equipmentTableIndex !== null &&
          equipmentTableIndex < equipmentTables.length
          ? equipmentTables[equipmentTableIndex].map((row) => row.id.toString())
          : [];

      workerList.push({
        id: worker.userId,
        typeId: worker.workerType,
        equipments,
        seq: worker.seq,
      });
    });

    const documentTypes = ["ra", "wp", "ec"];
    const documentList: { type: string; file: File; id: string }[] = [];

    documentTypes.forEach((documentType) => {

      switch (documentType) {
        case "ra":
          riskAssessmentFiles.map((file) => {
            documentList.push({ type: documentType , file: file.file as File, id: file.id.startsWith('temp_') ? "" : file.id});
          });
          break;
        case "wp":
          workPermitFiles.map((file) => {
            documentList.push({ type: documentType , file: file.file as File, id: file.id.startsWith('temp_') ? "" : file.id});
          });
          break;
        case "ec":
          equipmentChecklistFiles.map((file) => {
            documentList.push({ type: documentType , file: file.file as File , id: file.id.startsWith('temp_') ? "" : file.id});
          });
          break;
      }

    });

    try {
      if (localStorage.accessToken) {
        const schedule = {
          id: entry?.id,
          projectId: project?.id,
          locationId: position?.id,
          model: {
            workDate: date?.format("DD/MM/YYYY"),
            startTime: startTime?.format("HH:mm:ss"),
            endTime: endTime?.format("HH:mm:ss"),
            workType: workType,
            siteEquipments: equipmentTables[0] ?? [],
            workers: workerList.map((worker) => ({
              id: worker.id,
              typeId: worker.typeId,
              equipments: worker.equipments ?? [],
            })),
            siteDocuments: documentList.map((document) => ({
              type: document.type,
              files: document.file as File,
              id: document.id,
            })),
            allowedCheckInAccounts: selectedUsers,
          },
        };

        const formData = new FormData();
        formData.append("projectId", schedule.projectId);
        formData.append("locationId", schedule.locationId);
        formData.append("model.workDate", schedule.model.workDate || "");
        formData.append("model.startTime", schedule.model.startTime || "");
        formData.append("model.endTime", schedule.model.endTime || "");
        formData.append("model.workType", schedule.model.workType || "");
        ((equipmentTables[0] as any) || []).forEach((x: any, i: number) => {
          formData.append(`model.siteEquipments[${i}]`, x.id);
        });
        schedule.model.allowedCheckInAccounts.forEach((user, index) => {
          formData.append(`model.allowedCheckInAccounts[${index}]`, user);
        });
        schedule.model.workers.forEach((worker, index) => {
          formData.append(`model.workers[${index}].id`, worker.id);
          formData.append(
            `model.workers[${index}].typeId`,
            (worker.typeId as any) || ""
          );
          worker.equipments.forEach((equipment: any, subIndex: any) => {
            formData.append(
              `model.workers[${index}].equipments[${subIndex}]`,
              equipment
            );
          });
        });

        documentList.forEach((document, index) => {
          formData.append(
            `model.siteDocuments[${index}].file`,
            document.file
          );
          formData.append(
            `model.siteDocuments[${index}].id`,
            document.id || ""
          );
          formData.append(
            `model.siteDocuments[${index}].type`,
            document.type
          );
        });

        await updateSchedule({
          projectId: schedule.projectId,
          locationId: schedule.locationId,
          id: schedule.id,
          formData,
        }).then((res) => {
          if ("error" in res) {
            console.log(res.error);
            alert(`Update Schedule failed: ${res.error}`);
          } else {
            alert("Update Schedule Success");
            navigate("/work-schedule", {
              state: { project: project, position: position },
            });
          }
        });
      }
    } catch (error) {
      alert("An error occurred. Please refresh (F5) or login again.");
      console.log(error);
    }
  };
  const EquipmentColumns: TableHeader[] = [
    {
      field: "equipmentTypeId",
      headerName: t("Type"),
      width: 200,
      isSortable: true,
    },
    {
      field: "rfidNumber",
      headerName: t("RFID No."),
      width: 200,
      isSortable: true,
    },
    {
      field: "equipmentNumber",
      headerName: t("Equipment No."),
      width: 200,
      isSortable: true,
    },
    {
      field: "equipmentName",
      headerName: t("Equipment Name"),
      width: 200,
      isSortable: true,
    },
    {
      field: "manufacturer",
      headerName: t("Brand / Manufacturer"),
      width: 300,
      isSortable: true,
    },
    {
      field: "modelNumber",
      headerName: t("Model No."),
      width: 200,
      isSortable: true,
    },
    // { field: 'purchaseDate', headerName: 'Purchase Date', width: 300, isSortable: true },
    // { field: 'expiryDate', headerName: 'Expiry Date', width: 300, isSortable: true },
    // { field: 'certDueDate', headerName: 'Next Cal. / Cert Due Date', width: 200, isSortable: true },
    // { field: 'calPeriod', headerName: 'Cal. Period', width: 200, isSortable: true },
  ];
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  return (
    <MainContent type={projectPageName}>
      <BackgroundStyle sx={{ zIndex: 0 }}>
        <ListContainer className="data-table-overide-styles">
          {entry ? (
            <BigHeading>{t("Edit Work Schedule")}</BigHeading>
          ) : (
            <BigHeading>{t("Add Work Schedule")}</BigHeading>
          )}
          <SearchingBoxContainer>
            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={7}>
                <WorkDetailContainer>
                  <Box>
                    {entry ? (
                      <ProjectBar
                        newEntry={false}
                        user={createdBy}
                        updatedOn={updateTime}
                        status={status}
                        // updatedOn={updateTime?.format("DD/MM/YYYY HH:mm:ss")}
                        updatedBy={updatedBy}
                        riskAssessmentStatus={riskAssessmentStatus}
                      />
                    ) : (
                      <ProjectBar newEntry={true} />
                    )}
                  </Box>
                  <Box>
                    <WhiteContainer sx={{ height: "100%", minHeight: "400px" }}>
                      <Box sx={{ m: "10px" }}>
                        <FormControl fullWidth disabled={entry ? true : false}>
                          <FormLabel title={t("Work Type")} value="" />
                          <Select
                            value={workType}
                            onChange={(e) => setWorkType(e.target.value)}
                            displayEmpty
                            fullWidth
                          >
                            <MenuItem value="" disabled>
                              {t("Select Work Type")}
                            </MenuItem>
                            {workTypeArray.map((type) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                      <BigMapCard
                        selectPosition={position}
                        isInput={true}
                        startTime={startTime}
                        setStartTime={setStartTime}
                        endTime={endTime}
                        setEndTime={setEndTime}
                        date={date}
                        setDate={setDate}
                        project={project}
                        schedule={entry}
                      />
                    </WhiteContainer>
                  </Box>
                  {workType == "Confined Space" && (
                    <Box>
                      <WhiteContainer
                        sx={{ height: "100%", minHeight: "300px", mt: "20px" }}
                      >
                        <Box>
                          <BigHeading>{t("Document")}</BigHeading>
                          <Box sx={{ m: "20px" }}>
                            {/* Risk Assessment Section */}
                            <Box sx={{ mb: "24px" }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
                                <Box sx={{
                                  minWidth: '200px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  color: '#333'
                                }}>
                                  {t("Risk Assessment: ")}
                                </Box>
                              </Box>
                              <Box sx={{ ml: '20px' }}>
                                {entry ? (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                      <ShortBlueButton
                                        onClick={handleAddRiskAssessment}
                                        sx={{ minWidth: '180px' }}
                                      >
                                        {isRiskAssessmentOpened ? t("Edit Risk Assessment") : t("Add Risk Assessment")}
                                      </ShortBlueButton>
                                    </Box>
                                    <Box sx={{
                                      border: '1px dashed #ccc',
                                      borderRadius: '8px',
                                      p: 2,
                                      backgroundColor: '#fafafa'
                                    }}>
                                      <MultiFileUpload
                                        files={riskAssessmentFiles}
                                        onFilesChange={(files) => handleMultiFileChange(files, 'ra')}
                                        fileType="ra"
                                        accept="*"
                                        multiple={true}
                                        disabled={false}
                                      />
                                    </Box>
                                  </Box>
                                ) : (
                                  <Box sx={{
                                    color: '#666',
                                    fontStyle: 'italic',
                                    p: 2,
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                  }}>
                                    {t("Please Create Work Schedule First")}
                                  </Box>
                                )}
                              </Box>
                            </Box>

                            {/* Work Permit Section */}
                            <Box sx={{ mb: "24px" }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
                                <Box sx={{
                                  minWidth: '200px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  color: '#333'
                                }}>
                                  {t("Work Permit: ")}
                                </Box>
                              </Box>
                              <Box sx={{ ml: '20px' }}>
                                {entry ? (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                      <ShortBlueButton
                                        onClick={handleAddWorkPermit}
                                        sx={{ minWidth: '180px' }}
                                      >
                                        {isWorkPermitOpened ? t("Edit Work Permit") : t("Create Work Permit")}
                                      </ShortBlueButton>
                                    </Box>
                                    <Box sx={{
                                      border: '1px dashed #ccc',
                                      borderRadius: '8px',
                                      p: 2,
                                      backgroundColor: '#fafafa'
                                    }}>
                                      <MultiFileUpload
                                        files={workPermitFiles}
                                        onFilesChange={(files) => handleMultiFileChange(files, 'wp')}
                                        fileType="wp"
                                        accept="*"
                                        multiple={true}
                                        disabled={false}
                                      />
                                    </Box>
                                  </Box>
                                ) : (
                                  <Box sx={{
                                    color: '#666',
                                    fontStyle: 'italic',
                                    p: 2,
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                  }}>
                                    {t("Please Create Work Schedule First")}
                                  </Box>
                                )}
                              </Box>
                            </Box>

                            {/* Equipment Checklist Section */}
                            <Box sx={{ mb: "24px" }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
                                <Box sx={{
                                  minWidth: '200px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  color: '#333'
                                }}>
                                  {t("Equipment Checklist")}
                                </Box>
                              </Box>
                              <Box sx={{ ml: '20px' }}>
                              {entry ? ( <Box sx={{
                                  border: '1px dashed #ccc',
                                  borderRadius: '8px',
                                  p: 2,
                                  backgroundColor: '#fafafa'
                                }}>
                                  <MultiFileUpload
                                    files={equipmentChecklistFiles}
                                    onFilesChange={(files) => handleMultiFileChange(files, 'ec')}
                                    fileType="ec"
                                    accept="*"
                                    multiple={true}
                                    disabled={false}
                                  />
                                </Box>
                              ):(
                                <Box sx={{
                                  color: '#666',
                                  fontStyle: 'italic',
                                  p: 2,
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: '4px',
                                  border: '1px solid #ddd'
                                }}>
                                  {t("Please Create Work Schedule First")}
                                </Box>
                              )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </WhiteContainer>
                    </Box>
                  )}
                </WorkDetailContainer>
              </Grid>
              <Grid item xs={12} sm={5}>
                <WorkDetailContainer>
                  <Box>
                    <WhiteContainer sx={{ minHeight: "510px" }}>
                      <Box>
                        <BigHeading>{t("On Site Worker")}</BigHeading>

                        {workType === "Confined Space"
                          ? workerStates.map((x, index) => (
                            <div key={x.id as any}>
                              <RemovableFormDropDownList
                                key={x.id as any}
                                title={x.title}
                                value={x.name}
                                handleValueChange={(event: any) =>
                                  handleDropDownListChange(
                                    workerStates,
                                    event,
                                    index
                                  )
                                }
                                items={x.items}
                                removeButton={
                                  Number(x.id) > 3 &&
                                    Number(x.id) == workerStates.length - 1
                                    ? true
                                    : false
                                }
                                onCancel={() => {
                                  setWorkerStates((prevWorkerStates) =>
                                    prevWorkerStates.filter(
                                      (worker) =>
                                        worker.id !== workerStates.length - 1
                                    )
                                  );

                                  setEquipmentStates((prevEuipmentStates) =>
                                    prevEuipmentStates.filter(
                                      (equipment) =>
                                        equipment.id !==
                                        equipmentStates.length - 1
                                    )
                                  );
                                }}
                              />
                            </div>
                          ))
                          : workerStates
                            .filter((x) => x.workerType === 3)
                            .map((x) => {
                              // Find the original index in the full workerStates array
                              const originalIndex = workerStates.findIndex(
                                (worker) => worker.id === x.id
                              );
                              return (
                                <div key={x.id as any}>
                                  <RemovableFormDropDownList
                                    key={x.id as any}
                                    title={x.title}
                                    value={x.name}
                                    handleValueChange={(event: any) =>
                                      handleDropDownListChange(
                                        workerStates,
                                        event,
                                        originalIndex
                                      )
                                    }
                                    items={x.items}
                                    removeButton={
                                      Number(x.id) > 3 &&
                                        Number(x.id) == workerStates.length - 1
                                        ? true
                                        : false
                                    }
                                    onCancel={() => {
                                      setWorkerStates((prevWorkerStates) =>
                                        prevWorkerStates.filter(
                                          (worker) =>
                                            worker.id !==
                                            workerStates.length - 1
                                        )
                                      );

                                      setEquipmentStates(
                                        (prevEuipmentStates) =>
                                          prevEuipmentStates.filter(
                                            (equipment) =>
                                              equipment.id !==
                                              equipmentStates.length - 1
                                          )
                                      );
                                    }}
                                  />
                                </div>
                              );
                            })}
                        <ShortBlueButton
                          onClick={handleAddWorker}
                          disabled={workerStates.length > 10}
                        >
                          {t("Add Worker")}
                        </ShortBlueButton>
                      </Box>
                    </WhiteContainer>
                    <Box sx={{ mb: "20px" }}>
                      <WhiteContainer
                        sx={{ height: "100%", minHeight: "180px", mt: "20px" }}
                      >
                        <BigHeading>{t("Permission")}</BigHeading>
                        <Autocomplete
                          sx={{ m: "28px" }}
                          multiple
                          id="permission"
                          options={userList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option?.name}
                          renderOption={(props, option, { selected }) => {
                            const { ...optionProps } = props;
                            return (
                              <li {...optionProps}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={
                                    selectedUsers?.includes(option.id) ||
                                    selected
                                  }
                                />
                                {option?.name}
                              </li>
                            );
                          }}
                          style={{ width: "100%" }}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={handlePermissionChange}
                          value={userList?.filter((user) =>
                            selectedUsers?.includes(user.id)
                          )}
                        />
                      </WhiteContainer>
                    </Box>
                  </Box>
                </WorkDetailContainer>
              </Grid>
            </Grid>
          </SearchingBoxContainer>
          {equipmentStates.map((x, index) => (
            <div key={x.id as any}>
              {index >= 1 ? (
                <BigHeading>
                  {t(x.title) + `: ${workerStates[index + 1]?.name}`}
                </BigHeading>
              ) : (
                <BigHeading>{t(x.title)}</BigHeading>
              )}
              <AddEquipmentContainer
                onSelectRows={(selectedRows: any) =>
                  handleSelectRows(selectedRows, index)
                }
                selectedRows={equipmentTables[index]}
                equipmentTables={equipmentTables}
                workerNum={index}
                equipmentType={x.equipmentType}
              />
              <RecordTable
                columns={EquipmentColumns}
                rows={equipmentTables[index]}
                checkbox={false}
                deleteButton={false}
              // color="#8BB0DB"
              />
            </div>
          ))}
          <Box sx={{ display: "row" }}>
            {/* <ShortBlueButton onClick={() => { navigate(`/work-schedule`, { state: { project: project, position: position } }) }}>{t("Save")}</ShortBlueButton> */}
            {entry ? (
              <ShortBlueButton onClick={handleUpdateSchedule}>
                {t("Save")}
              </ShortBlueButton>
            ) : (
              <ShortBlueButton onClick={handleCreateSchedule}>
                {t("Save")}
              </ShortBlueButton>
            )}
            {/* {entry ?
                            <BackButton onClick={() => { navigate('/entry-detail', { state: { entry } }) }}>{t("Back")}</BackButton>
                            : <BackButton onClick={() => { navigate('/work-schedule', { state: { project: project, position: position } }) }}>{t("Back")}</BackButton>
                        } */}
            <BackButton
              onClick={() => {
                navigate("/work-schedule", {
                  state: { project: project, position: position },
                });
              }}
            >
              {t("Back")}
            </BackButton>
          </Box>
        </ListContainer>
      </BackgroundStyle>
    </MainContent>
  );
};
export default AddWorkSchedulePage;
